<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { Text, SelectCard, CardGrid } from '@Shelly/shelly-design-system';
	import { capFirstChar } from '../../../../../../../../../../helpers/utilities';
	import { format } from 'svelte-i18n';
	import VcSelectList from './VCSelectList.svelte';
	import VcNumber from './VCNumber.svelte';
	import VcText from './VCText.svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let sceneIsValid = false;
	export let actions = [];
	export let active_actions = []; // because it is only one action we can be sure that active_actions contains only one element

	const dispatch = createEventDispatcher();

	$: selectedVC = getInitialVC(actions);
	$: selectedVCValue = active_actions?.[0]?.value; // Get the value of the currently active VC element

	$: selectedVCOptions = selectedVC?.values || [];

	/**
	 * Get the currently active VC element from the list of actions
	 * @returns {Object}
	 */
	function getInitialVC(available_actions) {
		//Get current active action. E.g. {name: "number", index: "200", value: 0}
		let active = active_actions?.[0];

		if (import.meta.env.DEV) {
			console.log('[ActionsOnVC] active_actions', active_actions);
			console.log('[ActionsOnVC] ACTIONS', available_actions);
		}
		let actionObject = available_actions?.find((e) => {
			return (
				e.id === active?.name && //eg. number
				e.index == active?.index //e.g. 200
			);
		});

		return actionObject;
	}

	/**
	 * Get the default value of the VC element
	 * @returns {string | number}
	 */
	function getDefaultVCValue(): string {
		if (selectedVC?.values?.length > 0) {
			let selectVal =
				selectedVC?.config?.default_value ||
				selectedVC?.values.find((e) => e?.value !== '')?.value;

			if (import.meta.env.DEV) {
				console.log('[ActionsOnVC] getDefaultVCValue', selectVal);
			}
			return selectVal;
		}

		if (typeof selectedVC?.config?.default_value !== 'undefined') {
			return selectedVC?.config?.default_value;
		}

		return undefined;
	}

	/**
	 * Handle selections of specific VC for the action
	 * @param {Object} selected - Selected VC action object
	 */
	function handleSelectVC(selected) {
		selectedVC = selected;

		let default_value = getDefaultVCValue();
		handleOnChangeValue(default_value);
	}

	/**
	 * Handle changes in the value of the active VC
	 * @param {string | number} new_val - New value for the the VC
	 */
	const handleOnChangeValue = (new_val: string | number) => {
		if (import.meta.env.DEV) {
			console.warn('Change: handleOnChangeValue', sceneIsValid, new_val);
		}

		selectedVCValue = new_val;

		active_actions[0] = {
			name: selectedVC.id,
			index: selectedVC.index,
			value: selectedVCValue,
		};

		dispatch('change_active', { new_active: [...active_actions] });
	};
</script>

<Text element="h2" class="mb-s"
	>{capFirstChar(
		$format('label_select_device_property', {
			default: 'Select device property',
		}),
	)}</Text
>
<CardGrid sm={200} md={200} xl={200} noPaddingBottom>
	{#each actions as option}
		<div class="d-flex">
			<SelectCard
				cardBgColor={$showNewLayout ? 'color-1' : undefined}
				class="width-full"
				type="horizontal"
				variant="radio"
				title={option.name}
				icon={option?.icon}
				selected={selectedVC?.id === option?.id && selectedVC?.index === option?.index}
				on:click={() => {
					handleSelectVC(option);
				}}
			/>
		</div>
	{/each}
</CardGrid>

{#if selectedVC?.id}
	{#if selectedVC?.type === 'number'}
		<VcNumber
			action={selectedVC}
			value={selectedVCValue}
			bind:isValid={sceneIsValid}
			onChange={handleOnChangeValue}
		/>
	{:else if selectedVC?.type === 'text'}
		<VcText
			action={selectedVC}
			value={selectedVCValue}
			bind:isValid={sceneIsValid}
			onChange={handleOnChangeValue}
		/>
	{:else if !selectedVC?.shouldHideVirtualButtonEvents}
		<VcSelectList
			action={selectedVC}
			options={selectedVCOptions}
			value={selectedVCValue}
			bind:isValid={sceneIsValid}
			onChange={handleOnChangeValue}
		/>
	{/if}
{/if}
